import React, { useState } from 'react';
import { optimizarFoto } from '../utils/imagen';

// Carrusel simple de fotos: muestra todas las fotos del producto con
// flechas y puntitos. Si hay una sola, se ve como imagen normal.
// `ancho` = ancho al que se optimiza la foto (más chico = más rápido).
export default function CarruselFotos({ fotos = [], alt = '', height = 220, grayscale = false, ancho = 900 }) {
  const [i, setI] = useState(0);
  const lista = fotos.filter(Boolean);

  if (lista.length === 0) {
    return (
      <div style={{ height, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '40px', backgroundColor: 'white' }}>🛍️</div>
    );
  }

  const idx = Math.min(i, lista.length - 1);
  const ir = (delta, e) => {
    if (e) e.stopPropagation();
    setI((prev) => (prev + delta + lista.length) % lista.length);
  };

  const flecha = (lado) => ({
    position: 'absolute', top: '50%', transform: 'translateY(-50%)', [lado]: '6px',
    width: '30px', height: '30px', borderRadius: '999px', border: 'none',
    backgroundColor: 'rgba(255,255,255,0.85)', color: '#374151', fontSize: '20px', fontWeight: 'bold',
    cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 1px 4px rgba(0,0,0,0.2)',
  });

  return (
    <div style={{ position: 'relative', height, backgroundColor: 'white' }}>
      <img src={optimizarFoto(lista[idx], ancho)} alt={alt} loading="lazy"
        style={{ width: '100%', height: '100%', objectFit: 'contain', filter: grayscale ? 'grayscale(80%)' : 'none' }} />
      {lista.length > 1 && (
        <>
          <button onClick={(e) => ir(-1, e)} style={flecha('left')} aria-label="Anterior">‹</button>
          <button onClick={(e) => ir(1, e)} style={flecha('right')} aria-label="Siguiente">›</button>
          <div style={{ position: 'absolute', bottom: '8px', left: 0, right: 0, display: 'flex', justifyContent: 'center', gap: '5px' }}>
            {lista.map((_, k) => (
              <span key={k} style={{ width: '7px', height: '7px', borderRadius: '999px', backgroundColor: '#111827', opacity: k === idx ? 0.9 : 0.35 }} />
            ))}
          </div>
        </>
      )}
    </div>
  );
}
